import { memo } from 'react';

import { PDF_MAX_ZOOM, PDF_MIN_ZOOM, PDF_ZOOM_STEP } from '@air/react-pdfjs-viewer';

import { usePDFZoomContext } from '../contexts/PDFZoomContext';
import { ZoomSlider } from './ZoomSlider';

export const PDFZoomSlider = memo(() => {
  const { scale: currentZoom, updateScale, zoomIn, zoomOut } = usePDFZoomContext();

  const handleSliderChange = (value: number[]) => {
    const newZoom = value[0];
    updateScale(newZoom);
  };

  return (
    <ZoomSlider
      onZoomIn={zoomIn}
      onZoomOut={zoomOut}
      zoom={currentZoom}
      onSliderChange={handleSliderChange}
      min={PDF_MIN_ZOOM}
      max={PDF_MAX_ZOOM}
      step={PDF_ZOOM_STEP}
    />
  );
});

PDFZoomSlider.displayName = 'PDFZoomSlider';
